import React from "react";
import { AlertCircle, Loader2, RefreshCw } from "lucide-react";

export const AdminLoading = ({ label = "Caricamento..." }) => (
  <div data-testid="admin-loading" className="flex items-center gap-2 text-slate-400 py-8">
    <Loader2 className="h-4 w-4 animate-spin" /> {label}
  </div>
);

export const AdminError = ({ onRetry, message = "Impossibile caricare i dati. Riprova." }) => (
  <div data-testid="admin-error" className="flex flex-col items-start gap-3 rounded-xl border border-red-100 bg-red-50 p-5 text-sm">
    <div className="flex items-center gap-2 text-red-600 font-semibold">
      <AlertCircle className="h-4 w-4" /> {message}
    </div>
    {onRetry && (
      <button data-testid="admin-retry" onClick={onRetry} className="inline-flex items-center gap-1.5 rounded-full bg-red-600 text-white text-xs font-semibold px-4 py-2 hover:bg-red-700 transition-colors">
        <RefreshCw className="h-3.5 w-3.5" /> Riprova
      </button>
    )}
  </div>
);

export const AdminEmpty = ({ message = "Nessun dato disponibile." }) => (
  <div data-testid="admin-empty" className="rounded-xl border border-dashed border-slate-200 p-8 text-center text-slate-400 text-sm">
    {message}
  </div>
);
